import "./home.css";
import { useMemo, useState } from "react";
import {
  OperationOwnSales,
  OperationSalesMyProducts,
  OperationTop,
  OperationTurnover,
  Panel,
  PermissionGuard,
  UserGreeting,
} from "../../components";
import { useAuth, useDashboardSummary, useLanguage } from "../../hooks";
import { getCurrentMonthToTodayRange, toTopItems } from "../../utils";


const HomeScreen: React.FC = () => {
  const { t } = useLanguage();
  // `user` es el email del usuario logado (lo devuelve el login).
  const { rol, user } = useAuth();
  const isBrand = rol.includes("brand");
  const isChannel = rol.includes("channel");

  // El Top no tiene calendario: mes en curso hasta hoy, como el resto del Inicio.
  const [topRange] = useState(getCurrentMonthToTodayRange);

  // Ranking agregado en el back. Canal: % de activaciones por producto. Marca:
  // % de activaciones de sus productos por canal (retailer).
  const { summary: channelSummary } = useDashboardSummary("channel", topRange, isChannel);
  const { summary: brandSummary } = useDashboardSummary("brand", topRange, isBrand);

  const ownSalesBreakdown = useMemo(
    () => toTopItems(channelSummary, t.components.operations.donutchart.others),
    [channelSummary, t]
  );
  const transactionsBreakdown = useMemo(
    () => toTopItems(brandSummary, t.components.operations.donutchart.others),
    [brandSummary, t]
  );

  return (
    <>
      <Panel>
        <UserGreeting user={{ name: user ?? "" }} />

        <OperationTurnover />

        <PermissionGuard allowedRoles={["channel"]}>
          <section className="home-operations">
            <OperationOwnSales />
            <OperationTop
              title={t.components.operations.donutchart.sales}
              data={ownSalesBreakdown}
              currencySymbol="%"
            />
          </section>
        </PermissionGuard>

        <PermissionGuard allowedRoles={["brand"]}>
          <section className="home-operations">
            <OperationSalesMyProducts />
            <OperationTop
              title={t.components.operations.donutchart.myProducts}
              data={transactionsBreakdown}
              currencySymbol="%"
            />
          </section>
        </PermissionGuard>
      </Panel>
    </>
  );
};

export default HomeScreen;
